var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobiliftLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mobilift left  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobilift-left--",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,10 L12.8,10 C12.8552285,10 12.9,9.95522847 12.9,9.9 C12.9,9.87836298 12.8929822,9.85730962 12.88,9.84 L11.58,8.10666667 C11.5468629,8.06248389 11.4841828,8.05352958 11.44,8.08666667 C11.4324194,8.09235209 11.4256854,8.0990861 11.42,8.10666667 L10.12,9.84 C10.0868629,9.88418278 10.0958172,9.94686292 10.14,9.98 C10.1573096,9.99298221 10.178363,10 10.2,10 Z",
    id: "Up",
    fill: "currentColor",
    transform: "translate(11.500000, 9.000000) scale(-1, 1) rotate(180.000000) translate(-11.500000, -9.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2,6 L12.8,6 C12.8552285,6 12.9,5.95522847 12.9,5.9 C12.9,5.87836298 12.8929822,5.85730962 12.88,5.84 L11.58,4.10666667 C11.5468629,4.06248389 11.4841828,4.05352958 11.44,4.08666667 C11.4324194,4.09235209 11.4256854,4.0990861 11.42,4.10666667 L10.12,5.84 C10.0868629,5.88418278 10.0958172,5.94686292 10.14,5.98 C10.1573096,5.99298221 10.178363,6 10.2,6 Z",
    id: "Down",
    fill: "currentColor",
    transform: "translate(11.500000, 5.000000) scale(1, -1) rotate(-180.000000) translate(-11.500000, -5.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,4 C7.45160976,4 8,3.99833395 8,4.35601135 C8,4.59446295 8,7.4757925 8,13",
    id: "Path-9",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45842913,12.1896315 L7.06135829,13.0963575 C7.03920397,13.1469478 7.06225582,13.2059189 7.11284604,13.2280732 C7.12549415,13.233612 7.13915226,13.2364715 7.15295999,13.2364715 L8.74482945,13.2364715 C8.80005792,13.2364715 8.84482945,13.1917 8.84482945,13.1364715 C8.84482945,13.1222221 8.84178415,13.1081372 8.83589759,13.0951606 L8.42512543,12.1896315",
    id: "Path-2",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiliftLeft);
export default __webpack_public_path__ + "static/media/Mobilift_left.9a5d004e.svg";
export { ForwardRef as ReactComponent };